"use client";

import { useLocale } from "next-intl";
import { usePathname, useRouter } from "@/i18n/routing";
import { Button } from "@/components/ui/button";
import { Languages } from "lucide-react";

export function LanguageSwitcher() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  const toggleLanguage = () => {
    const nextLocale = locale === "ar" ? "en" : "ar";
    router.replace(pathname, { locale: nextLocale });
  };

  return (
    <Button
      variant="icon"
      onClick={toggleLanguage}
      className="gap-2"
      aria-label={
        locale === "ar"
          ? "Change language to English"
          : "تغيير اللغة إلى العربية"
      }
    >
      <Languages className="h-4 w-4" aria-hidden="true" />
      <span>{locale === "ar" ? "English" : "العربية"}</span>
    </Button>
  );
}
